import React from 'react';
import yaml from 'js-yaml';
// renderers is imported separately so Markdoc isn't sent to the client
import Markdoc, {renderers} from '@markdoc/markdoc'

import {getSchema, defaultObject} from '/vercel/path0/.dev/node_modules/@markdoc/next.js/src/runtime.js';
/**
 * Schema is imported like this so end-user's code is compiled using build-in babel/webpack configs.
 * This enables typescript/ESnext support
 */
const config = {};
import * as tags from '/vercel/path0/.dev/markdoc/tags.tsx'
import * as nodes from '/vercel/path0/.dev/markdoc/nodes.tsx'
import * as functions from '/vercel/path0/.dev/markdoc/functions.ts'
const schema = {
tags: defaultObject(tags),
nodes: defaultObject(nodes),
functions: defaultObject(functions),
...defaultObject(config),
};

/**
 * Source will never change at runtime, so parse happens at the file root
 */
const source = "---\ntitle: Sort\ndescription: Sort your lists and collections based on criteria.\nvideo:\nslug: sort\n---\n\nBy default, our list items show in the same order as the rows in our sheet. However, we can use **sort** to change this order. We can also enable **in-app sort** so that users can change the sorting themselves.\n\n## Default sort\n\nIn **Layout / Options** under **Sort** we'll see the following text.\n\n![](/docs/reference/ux/sort/sort-by-sheet.png)\n\nClicking on this text will allow us to customize the way our list is sorted. When we click on this we will see a dropdown and two direction controls.\n\n{% figure src=\"/docs/reference/ux/sort/sorting.gif\" caption=\"Sorting\" /%}\n\nIn addition to the default **Sheet Order** option, this dropdown menu will contain a **Random** sort and then all the columns in your sheet. If we choose another column then our list will be sorted by that column Alphabetically or Numerically - depending on the data in that column. At any time, we can reverse the order of your current sort by clicking the up or down arrows on the right.\n\nSorting can make more sense of the data in your lists. For example, the app below shows a list of drinks sorted by price in descending order.\n\n{% figure src=\"/docs/reference/ux/sort/sort-by-price.png\" caption=\"Sort by price\" /%}\n\n";
const filepath = "/reference/ux/sort.md";
const ast = Markdoc.parse(source);

/**
 * Like the AST, frontmatter won't change at runtime, so it is loaded at file root.
 * This unblocks future features, such a per-page dataFetchingFunction.
 */
const frontmatter = ast.attributes.frontmatter
  ? yaml.load(ast.attributes.frontmatter)
  : {};

const {components, ...rest} = getSchema(schema)

export async function getStaticProps(context) {
  const partials = {};

  // Ensure Node.transformChildren is available
  Object.keys(partials).forEach((key) => {
    partials[key] = Markdoc.parse(partials[key]);
  });

  const cfg = {
    ...rest,
    variables: {
      ...(rest ? rest.variables : {}),
      // user can't override this namespace
      markdoc: {frontmatter},
      // Allows users to eject from Markdoc rendering and pass in dynamic variables via getServerSideProps
      ...(context.variables || {})
    },
    partials,
    source,
  };

  /**
   * transform must be called in dataFetchingFunction to support server-side rendering while
   * accessing variables on the server
   */
  const content = await Markdoc.transform(ast, cfg);

  return {
    // Removes undefined
    props: JSON.parse(
      JSON.stringify({
        markdoc: {
          content,
          frontmatter,
          file: {
            path: filepath
          }
        },
      })
    ),
  };
}

export default function MarkdocComponent(props) {
  // Only execute HMR code in development
  return renderers.react(props.markdoc.content, React, {
    components: {
      ...components,
      // Allows users to override default components at runtime, via their _app
      ...props.components,
    },
  });
}
